import { defineComponent } from 'vue';
import useParentComponentEffect from '../../../hooks/useParentComponentEffect';

var script = /*#__PURE__*/ defineComponent(Object.assign({
    name: 'BPanoramaCoverageLayer'
}, { __name: 'index', emits: ['initd', 'unload'], setup(__props) {
        let panoramaCoverageLayer;
        const { ready } = useParentComponentEffect((map) => {
            panoramaCoverageLayer = new BMapGL.PanoramaCoverageLayer();
            map.addTileLayer(panoramaCoverageLayer);
            ready(map, panoramaCoverageLayer);
            return () => map.removeTileLayer(panoramaCoverageLayer);
        });
        return (_ctx, _cache) => {
            return null;
        };
    } }));

script.__file = "packages/components/layer/panorama-coverage/index.vue";

export { script as default };
